/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Lock state
 */
export interface LockState { 
    locked_by_first_name?: string;
    locked_by_last_name?: string;
    locked_by_mail?: string;
    locked_since?: string;
    locked_until?: string;
}

